var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconBriefcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.05469 13.4766C1.05469 13.4766 1.19669 15.2146 1.22969 15.7626C1.27369 16.4976 1.55769 17.3186 2.03169 17.8886C2.70069 18.6966 3.48869 18.9816 4.54069 18.9836C5.77769 18.9856 14.7727 18.9856 16.0097 18.9836C17.0617 18.9816 17.8497 18.6966 18.5187 17.8886C18.9927 17.3186 19.2767 16.4976 19.3217 15.7626C19.3537 15.2146 19.4957 13.4766 19.4957 13.4766",
    stroke: "#9BAEBC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.74609 3.329V2.958C6.74609 1.738 7.73409 0.75 8.95409 0.75H11.5361C12.7551 0.75 13.7441 1.738 13.7441 2.958L13.7451 3.329",
    stroke: "#9BAEBC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2451 14.6778V13.3838",
    stroke: "#9BAEBC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 6.38905V9.85605C2.918 11.1211 5.216 12.0071 7.738 12.3581C8.04 11.2571 9.033 10.4501 10.24 10.4501C11.428 10.4501 12.441 11.2571 12.723 12.3681C15.255 12.0171 17.562 11.1311 19.49 9.85605V6.38905C19.49 4.69505 18.127 3.33105 16.433 3.33105H4.067C2.373 3.33105 1 4.69505 1 6.38905Z",
    stroke: "#9BAEBC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBriefcase);
export default __webpack_public_path__ + "static/media/IconBriefcase.0d4ba51e.svg";
export { ForwardRef as ReactComponent };